import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const productCategoryImporterSelectors = importerSelectors(
  'productCategory.importer',
)

export default productCategoryImporterSelectors
